<template>
  <div>
    <div class="toggle desktop-view-only">
      <img
        :src="isList ? images[1]?.url : images[0]?.url"
        :class="[
          'toggle-btn',
          'toggle-btn--list',
          isList ? 'toggle-btn-active' : '',
        ]"
        @click="$emit('toggleTypeDisplay', 'list')"
        alt="toggle"
        :key="images[0]?.url"
      />
      <img
        :src="!isList ? images[3]?.url : images[2]?.url"
        :class="[
          'toggle-btn',
          'toggle-btn--tile',
          !isList ? 'toggle-btn-active' : '',
        ]"
        @click="$emit('toggleTypeDisplay', 'tile')"
        alt="toggle"
      />
    </div>
    <div class="toggle mobile-view-only">
      <img
        :src="isList ? images[1]?.url : images[3]?.url"
        :class="[
          'toggle-btn',
          'toggle-btn--list',
          isList ? 'toggle-btn-active' : '',
        ]"
        @click="$emit('toggleTypeDisplay', props.typeDisplay)"
        alt="toggle"
        :key="images[0]?.url"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  typeDisplay: {
    type: String,
    required: true,
  },
  isMobile: {
    type: Boolean,
    required: false,
  },
  images: {
    type: Array,
    required: true,
  },
});
const isList = computed(() => props.typeDisplay === 'list');
defineEmits(['toggleTypeDisplay']);
</script>

<style scoped lang="scss">
.toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-left: -9px;
  user-select: none;
  @include md-block {
    margin-left: -8px;
  }
  @include lg-block {
    height: auto;
    justify-content: space-between;
    width: 64px;
  }

  .toggle-btn {
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.94;
  }

  .toggle-btn--list {
    &:hover {
      transform: scale(1.1, 1.1);
      opacity: 0.9;
    }
  }

  .toggle-btn--tile {
    &:hover {
      transform: scale(1.1, 1.1);
      opacity: 0.9;
    }
  }

  .toggle-btn-active {
    display: block;
  }
}

.desktop-view-only {
  display: none;
  @include lg-block {
    display: flex;
  }
}

.mobile-view-only {
  display: flex;
  @include lg-block {
    display: none;
  }
}
</style>
